module.exports = __webpack_public_path__ + "images/category_lp/watch/assessment_achievements/6@2x_fa1530c1e51f9cdd3f05b27d383affae.png";